import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import GameMarketingResource from './game-marketing-resource-model'
import {
  CreateGameMarketingResourceAsync,
  DeleteGameMarketingResourceAsync,
  LoadGameMarketingResourcesAsync,
} from './gameMarketingResource-thunk'
const initialState: gameMarketingResourceSliceState = {
  gameMarketingResource: [],
  selected_gameMarketingResource: '',
  is_loading_gameMarketingResource: false,
  is_creating_gameMarketingResource: false,
  is_deleting_gameMarketingResource: false,
}
export interface gameMarketingResourceSliceState {
  gameMarketingResource: GameMarketingResource[]
  selected_gameMarketingResource?: string
  is_loading_gameMarketingResource: boolean
  is_creating_gameMarketingResource: boolean
  is_deleting_gameMarketingResource: boolean
}
export const gameMarketingResourceSlice = createSlice({
  name: 'gameMarketingResource',
  initialState,
  reducers: {
    setSelectedgameMarketingResource: (state, action) => {
      state.selected_gameMarketingResource = action.payload
    },
    clearStategameMarketingResource: (state) => {
      state.gameMarketingResource = []
      state.is_loading_gameMarketingResource = false
      state.is_creating_gameMarketingResource = false
      state.is_deleting_gameMarketingResource = false
    },
    mergegameMarketingResource: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_gameMarketingResource = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.gameMarketingResource = merge(
            state.gameMarketingResource,
            payload,
          ) as any
        }
      }
    },

    add_gameMarketingResource: (state, action) => {
      if (action.payload) {
        state.gameMarketingResource = [
          ...state.gameMarketingResource,
          action.payload,
        ]
      }
    },
    set_gameMarketingResource: (state, action) => {
      let { key, value, id } = action.payload
      state.gameMarketingResource = state.gameMarketingResource.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadGameMarketingResourcesAsync.pending, (state) => {
      state.is_loading_gameMarketingResource = true
    })
    builder.addCase(
      LoadGameMarketingResourcesAsync.fulfilled,
      (state, action) => {
        state.is_loading_gameMarketingResource = false
        if (action.payload) {
          state.gameMarketingResource = action.payload
        }
      },
    )
    builder.addCase(LoadGameMarketingResourcesAsync.rejected, (state) => {
      state.is_loading_gameMarketingResource = false
    })
    builder.addCase(CreateGameMarketingResourceAsync.pending, (state) => {
      state.is_creating_gameMarketingResource = true
    })
    builder.addCase(CreateGameMarketingResourceAsync.fulfilled, (state) => {
      state.is_creating_gameMarketingResource = false
    })
    builder.addCase(CreateGameMarketingResourceAsync.rejected, (state) => {
      state.is_creating_gameMarketingResource = false
    })
    builder.addCase(DeleteGameMarketingResourceAsync.pending, (state) => {
      state.is_deleting_gameMarketingResource = true
    })
    builder.addCase(
      DeleteGameMarketingResourceAsync.fulfilled,
      (state, action) => {
        state.is_deleting_gameMarketingResource = false
        if (state.gameMarketingResource) {
          state.gameMarketingResource = state.gameMarketingResource.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteGameMarketingResourceAsync.rejected, (state) => {
      state.is_deleting_gameMarketingResource = false
    })
  },
})

export const {
  clearStategameMarketingResource,
  setSelectedgameMarketingResource,
  set_gameMarketingResource,
  mergegameMarketingResource,
  add_gameMarketingResource,
} = gameMarketingResourceSlice.actions

export const get_gameMarketingResource =
  (id?: string) =>
  (state: {
    gameMarketingResource: {
      gameMarketingResource: GameMarketingResource[]
    }
  }): GameMarketingResource | null => {
    let temp = state?.gameMarketingResource?.gameMarketingResource?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.gameMarketingResource?.gameMarketingResource[0] || null
  }
export const get_selected_gameMarketingResource = (state: {
  gameMarketingResource: gameMarketingResourceSliceState
}): GameMarketingResource | null => {
  let id = state?.gameMarketingResource?.selected_gameMarketingResource
  let temp = state?.gameMarketingResource?.gameMarketingResource?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_gameMarketingResource = (state: {
  gameMarketingResource: {
    gameMarketingResource: GameMarketingResource[]
  }
}): GameMarketingResource[] => {
  let temp = state?.gameMarketingResource?.gameMarketingResource
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_gameMarketingResource_busy = (state: {
  gameMarketingResource: gameMarketingResourceSliceState
}) => {
  return (
    state?.gameMarketingResource.is_deleting_gameMarketingResource ||
    state?.gameMarketingResource.is_loading_gameMarketingResource ||
    state?.gameMarketingResource.is_creating_gameMarketingResource
  )
}
export const is_deleting_gameMarketingResource_busy = (state: {
  gameMarketingResource: gameMarketingResourceSliceState
}) => {
  return state?.gameMarketingResource.is_deleting_gameMarketingResource
}
export const is_loading_gameMarketingResource_busy = (state: {
  gameMarketingResource: gameMarketingResourceSliceState
}) => {
  return state?.gameMarketingResource.is_loading_gameMarketingResource
}
export const is_creating_gameMarketingResource_busy = (state: {
  gameMarketingResource: gameMarketingResourceSliceState
}) => {
  return state?.gameMarketingResource.is_creating_gameMarketingResource
}

export default gameMarketingResourceSlice.reducer
